import React from 'react';
import { ShieldCheck, Heart, Users, Clock } from 'lucide-react';

const features = [
  {
    title: 'Høj faglighed',
    description: 'Vi holder os løbende opdateret med den nyeste viden og forskning inden for almen medicin.',
    icon: ShieldCheck
  },
  {
    title: 'Nærvær & Omsorg',
    description: 'Hos os er du ikke bare et nummer. Vi tager os tid til at lytte og forstå din situation.',
    icon: Heart
  },
  {
    title: 'Erfarent Team',
    description: 'Vores team består af erfarne læger og personale, der arbejder tæt sammen om din sundhed.',
    icon: Users
  },
  {
    title: 'Fleksible tider',
    description: 'Vi tilbyder "Tid samme dag" og har udvidet åbningstid om onsdagen.',
    icon: Clock
  }
];

export default function InfoSection() {
  return (
    <section className="pt-24 pb-0 md:pb-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-0 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div className="px-6 md:px-0">
            <div className="flex items-center gap-4 mb-6">
              <div className="h-[1px] w-12 bg-[#4b717a]" />
              <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Om klinikken</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-sans font-medium text-black mb-8 leading-tight tracking-tight">
              Vi passer på dit helbred med omsorg og ekspertise
            </h2>
            <p className="text-slate-600 leading-relaxed mb-10 text-lg">
              Hellerup Lægehus er en moderne almen praksis, hvor vi lægger vægt på tilgængelighed og høj lægefaglig standard. Vi ønsker at skabe en tryg ramme for dine konsultationer.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {features.map((feature) => (
                <div key={feature.title} className="flex flex-col gap-3">
                  <div className="text-black">
                    <feature.icon size={24} />
                  </div>
                  <h4 className="font-sans font-medium text-lg text-black">{feature.title}</h4>
                  <p className="text-sm text-slate-500 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden shadow-none md:shadow-2xl">
              <img 
                src="https://assets.auxodev.dk/assets/3d56beb5-25cd-44c2-a35b-95780bd285dd/9b016b23-f998-4bb6-8084-3cb0375a5262.jpg" 
                alt="Klinikken" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
